!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("react-parallax", ["react"], t) : "object" == typeof exports ? exports["react-parallax"] = t(require("react")) : e["react-parallax"] = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    var t = {};
    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) __webpack_require__.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _inherits(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _setPrototypeOf(e, t);
    }
    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function _createSuper(e) {
      var t = function _isNativeReflectConstruct() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function _createSuperInternal() {
        var n,
          r = _getPrototypeOf(e);
        if (t) {
          var o = _getPrototypeOf(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return _possibleConstructorReturn(this, n);
      };
    }
    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" != typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }
    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Background = t.Parallax = void 0;
    var o = r(n(0)),
      i = function (e) {
        _inherits(Parallax, e);
        var t = _createSuper(Parallax);
        function Parallax() {
          return _classCallCheck(this, Parallax), t.apply(this, arguments);
        }
        return Parallax;
      }(o.default.Component);
    t.Parallax = i;
    var a = function (e) {
      _inherits(Background, e);
      var t = _createSuper(Background);
      function Background() {
        return _classCallCheck(this, Background), t.apply(this, arguments);
      }
      return Background;
    }(o.default.Component);
    t.Background = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.canUseDOM = t.getNodeHeight = t.isScrolledIntoView = t.getWindowHeight = void 0, t.getWindowHeight = function (e) {
      if (!e) return 0;
      var t = window,
        n = document,
        r = n.documentElement,
        o = n.getElementsByTagName("body")[0];
      return t.innerHeight || r.clientHeight || o.clientHeight;
    }, t.isScrolledIntoView = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        r = arguments.length > 2 ? arguments[2] : void 0;
      if (!r) return !1;
      var o = e.getBoundingClientRect().top - n,
        i = e.getBoundingClientRect().bottom + n;
      return o <= t.getWindowHeight(r) && i >= 0;
    }, t.getNodeHeight = function (e, n) {
      return e ? n && "clientHeight" in n ? n.clientHeight : t.getWindowHeight(e) : 0;
    }, t.canUseDOM = function () {
      return !("undefined" == typeof window || !window.document || !window.document.createElement);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Background = t.Parallax = void 0;
    var o = r(n(4));
    t.Parallax = o.default;
    var i = r(n(7));
    t.Background = i.default;
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function _createSuper(e) {
      var t = function _isNativeReflectConstruct() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function _createSuperInternal() {
        var n,
          r = _getPrototypeOf(e);
        if (t) {
          var o = _getPrototypeOf(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return _possibleConstructorReturn(this, n);
      };
    }
    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" != typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }
    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0)),
      i = n(1),
      a = n(5),
      c = n(2),
      u = r(n(6)),
      s = {
        position: "absolute",
        left: "50%",
        WebkitTransform: "translate3d(-50%, 0, 0)",
        transform: "translate3d(-50%, 0, 0)",
        WebkitTransformStyle: "preserve-3d",
        WebkitBackfaceVisibility: "hidden",
        MozBackfaceVisibility: "hidden",
        MsBackfaceVisibility: "hidden"
      },
      l = function (e) {
        !function _inherits(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && _setPrototypeOf(e, t);
        }(Parallax, e);
        var t = _createSuper(Parallax);
        function Parallax(e) {
          var n;
          return function _classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, Parallax), (n = t.call(this, e)).onWindowResize = function () {
            n.parentHeight = c.getNodeHeight(n.canUseDOM, n.parent), n.updatePosition();
          }, n.onWindowLoad = function () {
            n.updatePosition();
          }, n.onScroll = function () {
            if (n.canUseDOM) {
              var e = Date.now();
              e - n.timestamp >= 10 && c.isScrolledIntoView(n.node, 100, n.canUseDOM) && (window.requestAnimationFrame(n.updatePosition), n.timestamp = e);
            }
          }, n.onContentMount = function (e) {
            n.content = e;
          }, n.updatePosition = function () {
            if (n.content) {
              var e = !1;
              n.contentHeight = n.content.getBoundingClientRect().height, n.contentWidth = n.node.getBoundingClientRect().width, n.img && n.img.naturalWidth / n.img.naturalHeight < n.contentWidth / n.getImageHeight() && (e = !0);
              var t = a.getRelativePosition(n.node, n.canUseDOM),
                r = !!n.img,
                o = n.bg && n.state.splitChildren.bgChildren.length > 0;
              r && n.setImagePosition(t, e), o && n.setBackgroundPosition(t), r || o || n.setState({
                percentage: t
              });
            }
          }, n.state = {
            bgImage: e.bgImage,
            bgImageSrcSet: e.bgImageSrcSet,
            bgImageSizes: e.bgImageSizes,
            imgStyle: s,
            bgStyle: Object.assign(Object.assign({}, s), e.bgStyle),
            percentage: 0,
            splitChildren: a.getSplitChildren(e)
          }, n.canUseDOM = c.canUseDOM(), n.node = null, n.content = null, n.bgImageLoaded = !1, n.bgImageRef = void 0, n.parent = e.parent, n.parentHeight = c.getNodeHeight(n.canUseDOM, n.parent), n.timestamp = Date.now(), n.isDynamicBlur = a.getHasDynamicBlur(e.blur), n;
        }
        return function _createClass(e, t, n) {
          return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
        }(Parallax, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var e = this.props.parent,
              t = this.state,
              n = t.bgImage,
              r = t.bgImageSrcSet,
              o = t.bgImageSizes;
            this.parent = e || document, this.addListeners(), n ? this.loadImage(n, r, o) : this.updatePosition();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(e) {
            var t = this.props,
              n = t.parent,
              r = t.bgImage,
              o = t.bgImageSrcSet,
              i = t.bgImageSizes,
              a = this.state.bgImage;
            e.parent !== n && (this.removeListeners(this.parent), this.parent = n, n && this.addListeners()), this.parentHeight = c.getNodeHeight(this.canUseDOM, this.parent), a !== r && this.loadImage(r, o, i);
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.removeListeners(this.parent), this.releaseImage();
          }
        }, {
          key: "setBackgroundPosition",
          value: function setBackgroundPosition(e) {
            var t = this.props,
              n = t.disabled,
              r = t.strength,
              o = Object.assign({}, this.state.bgStyle);
            if (!n) {
              var i = "translate3d(-50%, ".concat((r < 0 ? r : 0) - r * e, "px, 0)");
              o.WebkitTransform = i, o.transform = i;
            }
            this.setState({
              bgStyle: o,
              percentage: e
            });
          }
        }, {
          key: "setImagePosition",
          value: function setImagePosition(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = this.props,
              r = n.disabled,
              o = n.strength,
              i = n.blur,
              c = t ? "auto" : "".concat(this.getImageHeight(), "px"),
              u = t ? "".concat(this.contentWidth, "px") : "auto",
              s = Object.assign(Object.assign({}, this.state.imgStyle), {
                height: c,
                width: u
              });
            if (!r) {
              var l = o < 0,
                f = (l ? o : 0) - o * e,
                p = "translate3d(-50%, ".concat(f, "px, 0)"),
                d = "none";
              i && (d = "blur(".concat(a.getBlurValue(this.isDynamicBlur, i, e), "px)")), s.WebkitTransform = p, s.transform = p, s.WebkitFilter = d, s.filter = d;
            }
            this.setState({
              imgStyle: s,
              percentage: e
            });
          }
        }, {
          key: "getImageHeight",
          value: function getImageHeight() {
            var e = this.props.strength,
              t = (e < 0 ? 2.5 : 1) * Math.abs(e);
            return Math.floor(this.contentHeight + t);
          }
        }, {
          key: "loadImage",
          value: function loadImage(e, t, n) {
            var r = this;
            this.releaseImage(), this.bgImageRef = new Image(), this.bgImageRef.onload = function (o) {
              r.setState({
                bgImage: e,
                bgImageSrcSet: t,
                bgImageSizes: n
              }, function () {
                return r.updatePosition();
              }), r.props.onLoad && r.props.onLoad(o);
            }, this.bgImageRef.onerror = this.bgImageRef.onload, this.bgImageRef.src = e, this.bgImageRef.srcset = t || "", this.bgImageRef.sizes = n || "";
          }
        }, {
          key: "releaseImage",
          value: function releaseImage() {
            this.bgImageRef && (this.bgImageRef.onload = null, this.bgImageRef.onerror = null, delete this.bgImageRef);
          }
        }, {
          key: "addListeners",
          value: function addListeners() {
            this.canUseDOM && this.parent && (this.parent.addEventListener("scroll", this.onScroll, !1), window.addEventListener("resize", this.onWindowResize, !1), window.addEventListener("load", this.onWindowLoad, !1));
          }
        }, {
          key: "removeListeners",
          value: function removeListeners(e) {
            this.canUseDOM && (e && e.removeEventListener("scroll", this.onScroll, !1), window.removeEventListener("resize", this.onWindowResize, !1), window.removeEventListener("load", this.onWindowLoad, !1));
          }
        }, {
          key: "render",
          value: function render() {
            var e = this,
              t = this.props,
              n = t.className,
              r = t.style,
              i = t.bgClassName,
              a = t.contentClassName,
              c = t.bgImageAlt,
              s = t.renderLayer,
              l = t.bgImageStyle,
              f = t.lazy,
              p = this.state,
              d = p.bgImage,
              g = p.bgImageSrcSet,
              _ = p.bgImageSizes,
              y = p.percentage,
              h = p.imgStyle,
              b = p.bgStyle,
              m = p.splitChildren;
            return o.default.createElement("div", {
              className: "react-parallax ".concat(n),
              style: Object.assign({
                position: "relative",
                overflow: "hidden"
              }, r),
              ref: function ref(t) {
                e.node = t;
              }
            }, d ? o.default.createElement("img", {
              className: i,
              src: d,
              srcSet: g,
              sizes: _,
              ref: function ref(t) {
                e.img = t;
              },
              alt: c,
              style: Object.assign(Object.assign({}, h), l),
              loading: f ? "lazy" : "eager"
            }) : null, s ? s(-(y - 1)) : null, m.bgChildren.length > 0 ? o.default.createElement("div", {
              className: "react-parallax-background-children",
              ref: function ref(t) {
                e.bg = t;
              },
              style: b
            }, m.bgChildren) : null, o.default.createElement(u.default, {
              onMount: this.onContentMount,
              className: a
            }, m.children));
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function getDerivedStateFromProps(e) {
            return {
              splitChildren: a.getSplitChildren(e)
            };
          }
        }]), Parallax;
      }(i.Parallax);
    l.defaultProps = {
      bgClassName: "react-parallax-bgimage",
      bgImageAlt: "",
      className: "",
      contentClassName: "",
      disabled: !1,
      strength: 100
    }, t.default = l;
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.setBlur = t.getBlurValue = t.getHasDynamicBlur = t.getSplitChildren = t.getRelativePosition = t.getPercentage = void 0;
    var r = n(0),
      o = n(2);
    t.getPercentage = function (e, t, n) {
      return (n - e) / (t - e) || 0;
    }, t.getRelativePosition = function (e, n) {
      if (!n) return 0;
      var r = e.getBoundingClientRect(),
        i = r.top,
        a = r.height,
        c = o.getNodeHeight(n),
        u = a > c ? a : c,
        s = Math.round(i > u ? u : i);
      return t.getPercentage(0, u, s);
    }, t.getSplitChildren = function (e) {
      var t = [],
        n = r.Children.toArray(e.children);
      return n.forEach(function (e, r) {
        var o = e;
        o.type && o.type.isParallaxBackground && (t = t.concat(n.splice(r, 1)));
      }), {
        bgChildren: t,
        children: n
      };
    }, t.getHasDynamicBlur = function (e) {
      return "object" === _typeof(e) && void 0 !== e.min && void 0 !== e.max;
    }, t.getBlurValue = function (e, t, n) {
      return e ? t.min + (1 - n) * t.max : t;
    }, t.setBlur = function (e, t) {
      e.style.webkitFilter = "blur(".concat(t, "px)"), e.style.filter = "blur(".concat(t, "px)");
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0));
    t.default = function ParallaxChildren(e) {
      var t = e.children,
        n = e.onMount,
        r = e.className;
      return o.default.createElement("div", {
        ref: function ref(e) {
          return n(e);
        },
        className: r || "react-parallax-content",
        style: {
          position: "relative"
        }
      }, t);
    };
  }, function (e, t, n) {
    "use strict";

    function _typeof(e) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function _createSuper(e) {
      var t = function _isNativeReflectConstruct() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function _createSuperInternal() {
        var n,
          r = _getPrototypeOf(e);
        if (t) {
          var o = _getPrototypeOf(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);
        return _possibleConstructorReturn(this, n);
      };
    }
    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" != typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }
    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(n(0)),
      i = function (e) {
        !function _inherits(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && _setPrototypeOf(e, t);
        }(Background, e);
        var t = _createSuper(Background);
        function Background() {
          return _classCallCheck(this, Background), t.apply(this, arguments);
        }
        return function _createClass(e, t, n) {
          return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
        }(Background, [{
          key: "render",
          value: function render() {
            var e = this.props,
              t = e.className,
              n = e.children;
            return o.default.createElement("div", {
              className: "react-parallax-background ".concat(t)
            }, n);
          }
        }]), Background;
      }(n(1).Background);
    i.defaultProps = {
      className: ""
    }, i.isParallaxBackground = !0, t.default = i;
  }]);
});